import React, { Fragment, useState } from 'react'
import { Box, Button, Grid, Tabs, Tab, IconButton, useMediaQuery, Theme } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import * as ls from 'local-storage'
import { useDispatch } from 'react-redux'
import { animateScroll as scroll } from 'react-scroll'
import { Snackbar, TabPanel } from '../../../../components'
import { CheckListItem } from '../check-list-item'
import { propsAction } from '../../../../store/props'
import { CheckListVariable } from '../check-list-variable'

export const UniversalTypeCheckList: React.FC<{
  img: any
  formProps: any
  className: any
  dataCheckList: any
  dataEmployee: any
  disableList: boolean
  updateInfo(): any
  handleChangeList: (data: any) => void
  onConfirmList: () => void
  onCloseList: () => void
}> = ({
  img = [],
  formProps,
  className,
  updateInfo,
  dataCheckList = [],
  dataEmployee = [],
  disableList = false,
  handleChangeList = () => {},
  onConfirmList = () => {},
  onCloseList = () => {},
}): JSX.Element => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const sm = useMediaQuery(({ breakpoints: { down } }: Theme) => down(600))

  const [tab, setTab] = useState<number>(0)

  const a11yProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    }
  }

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue)
  }

  const handleChange = (data: any) => {
    handleChangeList(data)
  }

  const onScrollTop = () => {
    scroll.scrollToTop()
  }

  return (
    <Box className={className.universal}>
      <Box id="variable">
        {dataCheckList.variable && dataCheckList.variable.length > 0 && !dataCheckList.all && (
          <Fragment key="variable">
            <CheckListVariable
              list={dataCheckList.variable}
              handleChangeList={handleChange}
              disableList={disableList}
              className={className}
              img={img}
            />
          </Fragment>
        )}
      </Box>

      <Box id="all">
        {dataCheckList.all &&
          dataCheckList.all.length > 0 &&
          dataCheckList.all.map((list: any, index: number) => {
            return (
              <Fragment key={`all${index}`}>
                <CheckListItem
                  index={index}
                  list={list}
                  handleChangeList={handleChange}
                  disableList={disableList}
                  className={className}
                  img={img}
                />
              </Fragment>
            )
          })}
      </Box>

      <Box id="personal">
        {!dataCheckList.tabs &&
          dataCheckList.personal &&
          dataCheckList.personal.length > 0 &&
          dataCheckList.personal.map((list: any, index: number) => {
            return (
              <Fragment key={`personal${index}`}>
                <CheckListItem
                  img={img}
                  list={list}
                  index={index}
                  className={className}
                  disableList={disableList}
                  handleChangeList={handleChange}
                />
              </Fragment>
            )
          })}
      </Box>

      <Box id="tabs">
        {dataCheckList.tabs &&
          dataCheckList.tabs.length > 0 &&
          dataCheckList.personal &&
          dataCheckList.personal.length > 0 && (
            <>
              <Grid container justifyContent="center">
                <Grid item xs="auto">
                  <Tabs value={tab} onChange={handleChangeTab}>
                    {dataCheckList.tabs.map((tabs: any, index: number) => {
                      return <Tab label={tabs.name} {...a11yProps(index)} />
                    })}
                  </Tabs>
                </Grid>

                <Grid item xs={12}>
                  {dataCheckList.tabs.map((tabs: any, index: number) => {
                    return (
                      <TabPanel value={tab} index={index}>
                        {dataCheckList.personal &&
                          dataCheckList.personal.map((list: any, indexPersonal: number) => {
                            if (list.custom_type === tabs.name) {
                              return (
                                <Fragment key={`personal${indexPersonal}`}>
                                  <CheckListItem
                                    img={img}
                                    list={list}
                                    index={indexPersonal}
                                    className={className}
                                    disableList={disableList}
                                    handleChangeList={handleChange}
                                  />
                                </Fragment>
                              )
                            } else {
                              return <></>
                            }
                          })}
                      </TabPanel>
                    )
                  })}
                </Grid>
                <Grid item xs="auto">
                  <Tabs value={tab} onChange={handleChangeTab}>
                    {dataCheckList.tabs.map((tabs: any, index: number) => {
                      return <Tab label={tabs.name} {...a11yProps(index)} />
                    })}
                  </Tabs>
                </Grid>
              </Grid>
            </>
          )}
      </Box>

      <Grid container justifyContent="center">
        <Grid item xs={12} sm={10}>
          <Snackbar {...formProps.snackbar} variantMessage="error" />
        </Grid>
      </Grid>

      <Box mt={5}>
        <Grid container justifyContent={sm ? 'center' : 'space-between'} spacing={3}>
          <Grid item>
            <Grid container direction="column" spacing={3}>
              {dataEmployee.checklist?.status !== 'FINISH' && (
                <Grid item>
                  <Button
                    color="secondary"
                    variant="contained"
                    className={className.btnConfirm}
                    disabled={disableList || !dataCheckList.all}
                    onClick={() => {
                      onConfirmList()
                    }}
                  >
                    Подтвердить данные и закрыть Чек&#8209;лист
                  </Button>
                </Grid>
              )}
              <Grid item>
                <Button
                  color="secondary"
                  variant="contained"
                  className={className.btnReject}
                  onClick={() => {
                    if (disableList) {
                      ls.remove('checklist')
                      const checklist_all = {
                        loaded: false,
                        employee: undefined,
                        checklist: undefined,
                      }
                      dispatch(propsAction.setProps({ checklist_all }))
                      updateInfo()
                      navigate('../lk')
                    } else onCloseList()
                  }}
                >
                  Выйти из Чек-листа
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <IconButton color="primary" onClick={onScrollTop}>
              <img src={img.upButton} alt="" className={className.iconTop} />
            </IconButton>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}
